




















import { Component, Prop, Vue } from "vue-property-decorator";
import { DxAutocomplete } from "devextreme-vue";
import Card from "@/components/default/Card.vue";
import notificationService from "@/services/notificationService";
import PdfViewer from "@/plugins/pdfjs/PdfViewer.vue";

import { DxForm, DxSimpleItem, DxLabel } from "devextreme-vue/form";

import { MeasuringStatesClient, MeasuringState } from "@/data/web-api-client";

@Component({
  components: {
    Card,
    DxForm,
    DxSimpleItem,
    DxLabel,
    DxAutocomplete,
    PdfViewer
  }
})
export default class MeasuringStateDocument extends Vue {
  @Prop({ required: true })
  private measuringState!: MeasuringState;
  private pdfSize: number = 450;

  private document: {
    loading: boolean;
    initialised: boolean;
    url: string;
  } = {
    loading: false,
    initialised: false,
    url: ""
  };

  private mounted() {
    this.pdfSize = window.innerHeight - 275;
    this.loadDocument();
  }

  async loadDocument() {
    try {
      this.document.loading = true;
      const result = await new MeasuringStatesClient(
        undefined,
        this.$axios
      ).getDocument(this.measuringState.documentNumber!.replaceAll("/", "-"));

      this.document.url = window.URL.createObjectURL(result.data);
      this.document.initialised = true;
    } catch (err) {
      notificationService.showAxiosError(err);
    } finally {
      this.document.loading = false;
    }
  }

  async generateDocument() {
    try {
      this.document.loading = true;
      const result = await new MeasuringStatesClient(
        undefined,
        this.$axios
      ).generateDocument(
        this.measuringState.documentNumber!.replaceAll("/", "-")
      );

      this.document.url = window.URL.createObjectURL(result.data);
    } catch (err) {
      notificationService.showAxiosError(err);
    } finally {
      this.document.loading = false;
    }
  }

  private emitGenerateContract() {
    this.$emit("generateContract");
  }
}
